'use client'

import type React from 'react'
import { User } from 'solar-icons'
import type { BottomCredits } from '@/lib/actions'
import { cn } from '@/lib/utils'

import { Avatar, AvatarFallback } from '@/components/ui'

interface ProfileDropdownProps extends React.ComponentPropsWithoutRef<'div'> {
  data: BottomCredits
}

export const ProfileDropdown = ({ data, className }: ProfileDropdownProps) => {
  return (
    <div
      className={cn(
        'flex select-none items-center gap-2 rounded-lg border border-gray-100 bg-gray-50 px-2 py-2.5',
        className,
      )}
    >
      <Avatar className="size-10">
        <AvatarFallback className="border border-gray-100 bg-white text-gray-600 dark:border-gray-700">
          <User className="size-4" strokeWidth={1.5} />
        </AvatarFallback>
      </Avatar>
      <div className="flex w-full flex-col">
        <div className="flex flex-col">
          <div className="flex text-sm">{data?.userName}</div>
          <div className="flex text-xs text-gray-700">
            Register ID. {data?.registerNumber}
          </div>
          <div className="flex text-xs text-gray-700">{data?.location}</div>
        </div>
      </div>
    </div>
  )
}
